import { TableRow } from "@mui/material";
import styled from "styled-components";
import { COLORS, CONDITION_COLORS } from "../../../constants/colors";
import PublicStyledTableCell from "../../publics/PublicStyledTableCell";
import { AllDeviceOverallTableRowProps } from "../../../constants/types";

const StyledTableRow = styled(TableRow)<any>(() => ({
  [`&`]: {
    background: "white",
    cursor: "pointer",
    fontSize: "1em",
  },
  [`&.disconnected`]: {
    background: COLORS.lightGray,
  },
  [`&:nth-of-type(even)`]: {
    padding: "0.65%",
    fontSize: "1em",
    fontWeight: 600,
    color: COLORS.fontColor,
  },
  [`&:hover`]: {
    background: COLORS.lightGray3,
  },
}));
const AllDeviceOverallTableRow = (props: AllDeviceOverallTableRowProps) => {
  // const onClick = () => {
  //   props.setModal({ modal: true, data: props.data });
  // };
  return (
    <>
      <StyledTableRow
        className={!props.data.status && "disconnected"}
        // onClick={onClick}
      >
        <PublicStyledTableCell>{props.data.no}</PublicStyledTableCell>
        <PublicStyledTableCell>{props.data.projectName}</PublicStyledTableCell>
        <PublicStyledTableCell>{props.data.category}</PublicStyledTableCell>
        <PublicStyledTableCell>{props.data.id}</PublicStyledTableCell>
        <PublicStyledTableCell>{props.data.name}</PublicStyledTableCell>
        <PublicStyledTableCell>{props.data.lastDate}</PublicStyledTableCell>
        <PublicStyledTableCell>{props.data.note}</PublicStyledTableCell>
      </StyledTableRow>
    </>
  );
};

export default AllDeviceOverallTableRow;
